var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoccia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.95,70.27l-.98-.98-.88.91c-1.38,1.39-135.21,136.46-135.21,244.42,0,75.21,61.05,136.4,136.12,136.4s136.12-61.19,136.12-136.4c0-90.01-97.57-206.9-135.16-244.34Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M285.47,35.58L249.98,0l-35.44,35.55c-6.11,6.11-149.53,151-149.53,279.06,0,102.22,82.99,185.39,185,185.39s185-83.16,185-185.39c0-128.63-143.47-273.01-149.53-279.04ZM250,451.02c-75.06,0-136.12-61.19-136.12-136.4,0-107.95,133.83-243.03,135.21-244.42l.88-.91.98.98c37.59,37.44,135.16,154.33,135.16,244.34,0,75.21-61.05,136.4-136.12,136.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoccia);
export default __webpack_public_path__ + "static/media/goccia.07ff818058e05af10e6392d9bb71cc5c.svg";
export { ForwardRef as ReactComponent };